<div class="roadmap" id="roadmap">
  <h3 class="small-title px-3">{{ 'roadmap.small_title' | translate }}</h3>
  <h2 class="section-title text-center mt-3 px-3">
    <span>{{ 'roadmap.title_1' | translate }}</span>
    <span class="text-primary">{{ 'roadmap.title_2' | translate }}</span>
  </h2>
  <p class="section-desc text-center mt-4 px-3 mx-auto">{{ 'roadmap.desc' | translate }}</p>
  <div class="d-none d-lg-flex container gap-5">
      @for (item of boxes; track item; let i = $index) {
      <div class="box">
        <div class="d-flex align-items-center gap-3 mb-4">
          <svg-icon src="/assets/images/svg-icons/phase-complete.svg"></svg-icon>
          <div>
            <p class="font-16 mb-0 phase">{{ item.phase | translate }}</p>
            <p class="font-20 mb-0">{{ item.title | translate }}</p>
          </div>
        </div>
        <ul>
          @for (list_item of item.features; track list_item; let j = $index) {
            <li class="d-flex gap-2 align-items-center">
              <img [src]="getListItemIcon(i, j, item.isCompleted)" alt="ticker" loading="lazy" />
              {{ list_item | translate }}
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <owl-carousel-o [options]="slideOption" class="d-flex d-lg-none boxes-wrapper" *ngIf="canRender">
    @for (item of boxes; track item; let i = $index) {
      <ng-template carouselSlide>
        <div class="box">
          <div class="d-flex align-items-center gap-3 mb-4">
            <svg-icon src="/assets/images/svg-icons/phase-complete.svg"></svg-icon>
            <div>
              <p class="font-14 mb-0 phase">{{ item.phase | translate }}</p>
              <p class="font-20 mb-0">{{ item.title | translate }}</p>
            </div>
          </div>
          <ul>
            @for (list_item of item.features; track list_item; let j = $index) {
              <li class="d-flex gap-2 align-items-center">
                <img [src]="getListItemIcon(i, j, item.isCompleted)" alt="ticker" loading="lazy" />
                {{ list_item | translate }}
              </li>
            }
          </ul>
        </div>
      </ng-template>
    }
  </owl-carousel-o>
</div>
